import React from 'react';
import { currency } from '@utils';
import { useSelector } from 'react-redux';
import { mdiCommentAlertOutline } from '@mdi/js';
import { Icons } from '@components';

export const Alerta = () => {
  const { totalParcelasEmAtraso, valorTotalEmAtraso, contratos } = useSelector(
    (state) => state.emprestimo
  );

  const hasContratos = contratos.length > 0;

  return hasContratos ? (
    <div className="gap-4 pt-0 pt-md-4 pb-32 d-block d-lg-flex align-items-center justify-content-between">
      <div className="d-block d-md-flex mb-32 mb-md-4 mb-lg-0">
        <Icons
          path={mdiCommentAlertOutline}
          color="var(--primary-color)"
          size={2}
          style={{ marginRight: 4 }}
        />
        <div className="ms-0 ms-md-32">
          <p className="text-black fw-bold ts-20 mb-2">
            Aviso - Parcelas em atraso
          </p>
          <ol className="ts-14 text-muted ps-3">
            <li>
              Os valores em atraso listados não estão corrigidos. A atualização
              dos valores deve ser realizada pelo botão PARCELAS EM ATRASO.
            </li>
            <li>
              Conforme regulamento, novas contratações de emprestimo não podem
              ser realizadas se existirem valores em atraso de contratos em
              andamento.
            </li>
          </ol>
        </div>
      </div>
      <div className="d-block d-md-flex text-nowrap">
        <div className="mb-4 mb-md-0">
          <p className="ts-14 fw-bold">Em atraso</p>
          <p className="ts-32 fw-bold">{`${totalParcelasEmAtraso} parcela${
            totalParcelasEmAtraso !== 1 ? 's' : ''
          }`}</p>
        </div>
        <div className="ms-0 ms-md-32">
          <p className="ts-14 fw-bold">Valor total</p>
          <p className="ts-32 fw-bold">{currency(valorTotalEmAtraso)}</p>
        </div>
      </div>
    </div>
  ) : (
    <h4>Você não tem contrato de empréstimo com a fundação</h4>
  );
};
